<template>
  <div v-if="isEnabled" class="tts-button btn btn--dark btn--with-icon" @click="openPlayer">
    <div class="">
      <DefaultIconsPlay />
    </div>
    <span>{{ $t('articles.tts_listen_article') }}</span>
  </div>
</template>

<script setup lang="ts">
import {useEvent} from "~/composables/useEventBus"
import type TtsPlayerEventPayload from "~/libs/interfaces/TtsPlayerEventPayload"

const props = defineProps({
  id: {type: String, required: false},
  title: {type: String, required: false},
})

const payload: TtsPlayerEventPayload = {
  id: props.id,
  title: props.title,
  startTime: 0
}

onMounted(() => {
  useEvent("tts-player:init", payload);
});



const openPlayer = () => {
  // isOpened.value = true
  useEvent('tts-player:open', payload)
}

const isEnabled = computed(() => {
  return useTts().isEnabled()
})
</script>

<style lang="scss" scoped>

</style>
